module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"listIsEmpty":"List is empty.","noDataToShow":"No data to show.","clear":"clear","addMore":"Add more...","add":"Add","selectedCount":"{count} selected"},"ua":{"listIsEmpty":"Список порожній.","noDataToShow":"Дані відсутні.","clear":"очистити","addMore":"Додати ще...","add":"Додати","selectedCount":"{count} обрано"}}')
  delete Component.options._Ctor
}
